module.exports = __webpack_public_path__ + "img/trollegate001.e3ee996f.jpg";